import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M28.7121 42.8549H5.14062V14.5692L16.9263 5.14062L28.7121 14.5692V42.8549Z",
      stroke: "#454342",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M28.7109 42.8504H42.8538V22.4219H28.7109",
      stroke: "#454342",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }